import AppLink from 'components/AppLink'
import AppLogo from 'components/AppLogo'
import React from 'react'
import styled from '@emotion/styled'
import { spacer } from 'stylist'

const StyledAppLogo = styled(AppLogo)`
  margin-bottom: ${spacer(4)};
`

const AppLogoLink = ({ clientId }) => (
  <AppLink clientId={clientId}>
    <StyledAppLogo clientId={clientId} />
  </AppLink>
)

export default AppLogoLink



// WEBPACK FOOTER //
// ./src/components/AppLogoLink.js